import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addDocumentType, deleteDocumentType, getAllDocumentType, updateDocumentType } from '../../redux/rtk/features/masters/documentTypeSlice';
import PageTitle from '../page-header/PageHeader';



const DocumentTypeMaster = () => {
  const { Title } = Typography;

  const [editingdocument, setEditingdocument] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.documentType);

  useEffect(() => {
    dispatch(getAllDocumentType());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingdocument) {
        // Update existing document
        const result = await dispatch(
          updateDocumentType({ id: editingdocument.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllDocumentType());
        } else {
          message.error('Error updating document!');
        }
      } else {
        // Add new document
        const result = await dispatch(addDocumentType(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllDocumentType());
        } else {
          message.error('Error adding document!');
        }
      }
      setEditingdocument(false);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update document!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteDocumentType(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllDocumentType()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'documentType',
      key: 'documentType',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => { 
            setEditingdocument(record); 
            form.setFieldsValue(record) }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this document type?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingdocument ? 'Edit Document Type' : 'Add Document Type'}>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="document-type-form"
              labelCol={{ span: 11 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="documentType"
                label="Document Name"
                rules={[{ required: true, message: 'Please enter a document name!' }]}
              >
                <Input placeholder="Enter document name" />
              </Form.Item>

              <Button type="primary" block htmlType="submit">
                {editingdocument ? 'Update Document Name' : 'Add Document Name'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Document Type List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentTypeMaster;
